<template>
  <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 4C1.5 3.83333 4.5 4 6.5 2C7.83333 3 11.3 4.4 14.5 2C16.5 4 18.9 4 20.5 4"
      class="stroke-current"
      stroke-width="2"
    />
    <path
      d="M0.5 10C1.5 9.83333 4.5 10 6.5 8C7.83333 9 11.3 10.4 14.5 8C16.5 10 18.9 10 20.5 10"
      class="stroke-current"
      stroke-width="2"
    />
    <path
      d="M0.5 16C1.5 15.8333 4.5 16 6.5 14C7.83333 15 11.3 16.4 14.5 14C16.5 16 18.9 16 20.5 16"
      class="stroke-current"
      stroke-width="2"
    />
  </svg>
</template>
